@if (reordering()) {
  <td
    class="column-type-reorder"
    pReorderableColumn
    pTooltip="Przenieś"
    [pReorderableColumnDisabled]="!reordering()">
    <app-icon [icon]="Icon.List" />
  </td>
}

@for (column of columns(); track column) {
  <td
    pFrozenColumn
    [frozen]="valueOrDefault(column.frozen, false)"
    [bodyRowSelectionDisabled]="bodyRowSelectionDisabled()"
    [column]="column"
    [customCellTemplateRef]="customCellTemplateRef()"
    [dataKey]="dataKey()"
    [model]="model()"
    [order]="order()"
    [appendLabel]="appendLabels()"
    [ngClass]="[column | columnTypeCssClass, column | columnKeyCssClass]"
    app-table-body-cell></td>
}

<ng-container>
  <td
    [alignFrozen]="appendLabels() ? 'left' : 'right'"
    class="column-type-actions"
    pFrozenColumn>
    @if (appendLabels()) {
      <span class="p-datatable-label">Akcje</span>
    }

    @if (itemActions(); as itemActions) {
      <app-table-item-actions
        [itemActions]="itemActions"
        [model]="model()" />
    }
  </td>
</ng-container>
